import type { AccessorKeyColumnDef, ColumnDef, GroupColumnDef, SortingState } from "@tanstack/react-table"

/**
 * Filter out columns that no longer exist in the groupColumns definition, for example if a variant was removed.
 */
export const filterSorting = (sorting: SortingState, groupColumns: Array<GroupColumnDef<any>>): SortingState => {
  const columnIds = groupColumns.flatMap((groupColumn) =>
    groupColumn.columns?.map((c) => (c as AccessorKeyColumnDef<any>).accessorKey),
  )
  return sorting.filter((columnSort) => columnIds.includes(columnSort.id))
}

export const accessorKey = (column: ColumnDef<any>): string | undefined =>
  "accessorKey" in column ? String(column.accessorKey) : undefined
